const defaultState = {
  whatsAppCart: [],
};

export default (state = defaultState, action) => {
  switch(action.type){
    case 'SET_WHATSAPP_CART':
      return {
        ...state,
        whatsAppCart: action.whatsAppCart,
      }
    default:
      return state;
  };
};